import { Button } from '@pique/component';
import clsx from 'clsx';
import type React from 'react';
import {
  cloneElement,
  type HTMLAttributes,
  type ReactElement,
  type Ref,
  type SVGProps,
} from 'react';

import * as styles from './empty-section.css';

interface ExplorerEmptySectionProps extends HTMLAttributes<HTMLDivElement> {
  icon: ((props: SVGProps<SVGSVGElement>) => React.JSX.Element) | ReactElement;
  message: string;
  messageTestId?: string;
  actionText?: string;
  onActionClick?: () => void;
}

export function ExplorerEmptySection({
  ref,
  icon: Icon,
  message,
  messageTestId,
  actionText,
  children,
  className,
  onActionClick,
  ...attrs
}: ExplorerEmptySectionProps & { ref?: Ref<HTMLDivElement> }) {
  const icon =
    typeof Icon === 'function' ? (
      <Icon className={styles.icon} />
    ) : (
      cloneElement<{ className?: string }>(Icon as ReactElement<{ className?: string }>, { className: styles.icon })
    );

  return (
    <div className={clsx(styles.content, className)} ref={ref} {...attrs}>
      <div
        className={clsx(styles.iconWrapper, onActionClick && styles.iconWrapperClickable)}
        onClick={onActionClick}
      >
        {icon}
      </div>
      <div data-testid={messageTestId} className={styles.message}>
        {message}
      </div>
      {actionText ? (
        <Button className={styles.newButton} onClick={onActionClick}>
          {actionText}
        </Button>
      ) : null}
      {children}
    </div>
  );
}
